import { FieldControl } from 'spark-core-dx/components';
import { SystemTypes } from 'spark-core-dx/services';

export const FilterFields = ({
	isFranchisee,
	selectedFilters,
	getFilterDataByKey,
	handleDataUpdate,
	handleFilterRequest
}) => {
	const customerData = getFilterDataByKey("global_customer_options");
	const franchiseeData = getFilterDataByKey("global_tenant_options");

	return (
		<div className="dashboard-filter-fields">
			{isFranchisee && (
				<FieldControl
					className={"dashboard-filter-field"}
					fieldMetadata={{
						FieldName: "Franchisee",
						DisplayName: "Franchisee",
						FieldType: SystemTypes.UIFieldType.MultiSelectList,
						DataJson: franchiseeData,
					}}
					value={selectedFilters.franchiseeFilters || []}
					onChange={(value) => handleDataUpdate(value, 'franchisee')}
					onBlur={() => handleFilterRequest()}
				/>
			)}

			<FieldControl
				className={"dashboard-filter-field"}
				fieldMetadata={{
					FieldName: "Customer",
					DisplayName: "Customer",
					FieldType: SystemTypes.UIFieldType.MultiSelectList,
					DataJson: customerData,
				}}
				value={selectedFilters.customerFilters || []}
				onChange={(value) => handleDataUpdate(value, 'customer')}
				onBlur={() => handleFilterRequest()}
			/>
		</div>
	);
};